// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "机械工程材料",
      "tec": "贺优优",
      "week": "1-2,5-13周",
      "add": "教学楼A座425机械"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "刘永楠",
      "week": "1-9,12-18周",
      "add": "教学楼C座110教务"
    },
    {
      "sub": "大学物理（下)",
      "tec": "赵明明",
      "week": "1-2,5-9,12-18周",
      "add": "教学楼C座212教务"
    },
    [
      {
        "sub": "理论力学",
        "tec": "孙长青",
        "week": "5-9周",
        "add": "教学楼A座419机械"
      },
      {
        "sub": "理论力学",
        "tec": "孙长青",
        "week": "10-14周",
        "add": "教学楼A座419机械"
      }
    ],
    0
  ],
  "2": [
    {
      "sub": "马克思主义基本原理",
      "tec": "马继强",
      "week": "1-2,5,7-9,12-17周",
      "add": "教学楼A座422机械"
    },
    0,
    [
      {
        "sub": "能源电力工程英语（上）",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼F座101自控"
      },
      {
        "sub": "25自机2-3",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "教学楼B座119自控"
      },
      {
        "sub": "25自机1-2",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "25自机2-2",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25自机1-1",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "25自机1-3",
        "tec": "马丹",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25自机1-4",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "教学楼B座220能动"
      },
      {
        "sub": "25自机1-5",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "25自机2-1",
        "tec": "丁璐瑶",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      }
    ],
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "李宏波",
      "week": "1-2,5-18周",
      "add": "教学楼A座419机械"
    },
    0
  ],
  "3": [
    [
      {
        "sub": "机械工程材料",
        "tec": "贺优优",
        "week": "1周",
        "add": "教学楼A座422机械"
      },
      {
        "sub": "理论力学",
        "tec": "孙长青",
        "week": "5-9周",
        "add": "教学楼A座419机械"
      },
      {
        "sub": "理论力学",
        "tec": "孙长青",
        "week": "10-14周",
        "add": "教学楼A座419机械"
      }
    ],
    {
      "sub": "大学物理（下)",
      "tec": "赵明明",
      "week": "1-2,5-9,12-18周",
      "add": "教学楼C座212教务"
    },
    0,
    0,
    {
      "sub": "形势与政策",
      "tec": "张文东",
      "week": "1-2,5-6周",
      "add": "教学楼C座210教务"
    }
  ],
  "4": [
    0,
    {
      "sub": "马克思主义基本原理",
      "tec": "马继强",
      "week": "1-2,5,7-9,12-17周",
      "add": "教学楼A座421机械"
    },
    {
      "sub": "现代设计项目实践",
      "tec": "范智广",
      "week": "1-2,5-10周",
      "add": "教学楼A座323制图教室"
    },
    [
      {
        "sub": "现代设计项目实践",
        "tec": "范智广",
        "week": "1-2,5-10周",
        "add": "教学楼A座323制图教室"
      },
      {
        "sub": "科技文献检索",
        "tec": "董玉萍",
        "week": "11-14周",
        "add": "教学楼A座420机械"
      }
    ],
    0
  ],
  "5": [
    [
      {
        "sub": "大学英语（三）",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "25自机1-5",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25自机1-2",
        "tec": "马丹",
        "week": "1-14周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "25自机1-4",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25自机1-3",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "教学楼B座119自控"
      },
      {
        "sub": "25自机1-1",
        "tec": "丁璐瑶",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "25自机2-4",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25自机2-2",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼F座101自控"
      },
      {
        "sub": "25自机2-1",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      }
    ],
    {
      "sub": "概率论与数理统计",
      "tec": "刘永楠",
      "week": "1-9,12-18双周",
      "add": "教学楼C座110教务"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "王莹莹",
        "week": "1-3,5-18周",
        "add": "男乒"
      },
      {
        "sub": "男网",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "搏击",
        "tec": "李莉",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "女篮",
        "tec": "郝策",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男网",
        "tec": "张慧",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "健美操",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男羽",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "足球",
        "tec": "李灏",
        "week": "1-18周",
        "add": "男乒"
      }
    ],
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
